<template>
  <div class="tab-page">
    <div class="type-wrapper">
      <span :class="{ active: type === 'pod' }" @click="selectType('pod')">
        Pod
      </span>
    </div>
    <ProductionPod v-if="type === 'pod'" />
  </div>
</template>

<script>
import ProductionPod from '@/components/production/ProductionPod'
export default {
  data() {
    return {
      type: 'pod'
    }
  },
  components: {
    ProductionPod
  },
  methods: {
    selectType(type) {
      this.type = type
    }
  }
}
</script>
